import React from "react";
import { useParams } from "react-router-dom";
import { fetchUserAgenda } from "../../methods/agenda/agendaRequests";
import AgendaSummaryView from "../../components/agenda/AgendaSummaryView";

export default function UserAgendaPage() {
  const { id } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [agenda, setAgenda] = React.useState({ summary: null, items: [] });

  const loadAgenda = React.useCallback(async () => {
    if (!id) {
      setAgenda({ summary: null, items: [] });
      setError("Missing user id.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");

    const response = await fetchUserAgenda(id);

    if (!response?.success) {
      setAgenda({ summary: null, items: [] });
      setError(response?.error || "Failed to load user agenda.");
      setLoading(false);
      return;
    }

    setAgenda({
      summary: response.data?.summary || null,
      items: Array.isArray(response.data?.items) ? response.data.items : [],
    });
    setLoading(false);
  }, [id]);

  React.useEffect(() => {
    loadAgenda();
  }, [loadAgenda]);

  return (
    <AgendaSummaryView
      title="User Agenda"
      subtitle="Review this user's appointments, class bookings, and assigned schedule items."
      loading={loading}
      error={error}
      agenda={agenda}
      onRefresh={loadAgenda}
    />
  );
}
